import type { FSA, SimpleFSA } from '@makemydeal/dr-browser-utils';

export const CLICK_CREDIT_BUREAU_SLIDEOUT_BUTTON = 'CLICK_CREDIT_BUREAU_SLIDEOUT_BUTTON';
export const CLOSE_CREDIT_BUREAU_SLIDEOUT = 'CLOSE_CREDIT_BUREAU_SLIDEOUT';
export const SAVE_COMPLIANCE = 'SAVE_COMPLIANCE';
export const CANCEL_COMPLIANCE = 'CANCEL_COMPLIANCE';
export const DEAL_SPD_REQUEST = 'DEAL_SPD_REQUEST';
export const DEAL_SPD_SUCCESS = 'DEAL_SPD_SUCCESS';
export const DEAL_SPD_FAILURE = 'DEAL_SPD_FAILURE';
export const PII_CONSISTENCY_REQUEST = 'PII_CONSISTENCY_REQUEST';
export const PII_CONSISTENCY_SUCCESS = 'PII_CONSISTENCY_SUCCESS';
export const PII_CONSISTENCY_FAILURE = 'PII_CONSISTENCY_FAILURE';
export const RESEND_ID_VERIFICATION_REQUEST = 'RESEND_ID_VERIFICATION_REQUEST';
export const RESEND_ID_VERIFICATION_SUCCESS = 'RESEND_ID_VERIFICATION_SUCCESS';
export const RESEND_ID_VERIFICATION_FAILURE = 'RESEND_ID_VERIFICATION_FAILURE';
export const CLEAR_RESEND_ID_VERIFICATION = 'CLEAR_RESEND_ID_VERIFICATION';

export type FetchDealSpdAction = SimpleFSA<typeof DEAL_SPD_REQUEST>;

export type FetchDealSpdSuccessAction = FSA<typeof DEAL_SPD_SUCCESS, any>;

export type FetchDealSpdFailureAction = FSA<typeof DEAL_SPD_FAILURE, any>;

export type DealSpdActions = FetchDealSpdAction | FetchDealSpdSuccessAction | FetchDealSpdFailureAction;

export type FetchPIIConsistencyAction = SimpleFSA<typeof PII_CONSISTENCY_REQUEST>;

export type FetchPIIConsistencySuccessAction = FSA<typeof PII_CONSISTENCY_SUCCESS, any>;

export type FetchPIIConsistencyFailureAction = FSA<typeof PII_CONSISTENCY_FAILURE, any>;

export type ResendIdVerificationAction = SimpleFSA<typeof RESEND_ID_VERIFICATION_REQUEST>;

export type ResendIdVerificationSuccessAction = FSA<typeof RESEND_ID_VERIFICATION_SUCCESS, any>;

export type ResendIdVerificationFailureAction = FSA<typeof RESEND_ID_VERIFICATION_FAILURE, any>;

export type ClearResendIdVerificationAction = SimpleFSA<typeof CLEAR_RESEND_ID_VERIFICATION>;
